var dotDigital = window.dotDigital;
var product = window.product;
var customerEmail = window.customerEmail;
window.Shopify.loadFeatures([{
  name: 'consent-tracking-api',
  version: '0.1'
}], function (error) {
  if (error) {
    return;
  }
  var marketingAllowed = window.Shopify.customerPrivacy.currentVisitorConsent().marketing;
  if (marketingAllowed === 'yes') {
    dotDigitalScript();
  }
});
document.addEventListener('visitorConsentCollected', function (event) {
  var marketingAllowed = event.detail.marketingAllowed;
  if (marketingAllowed === true) {
    dotDigitalScript();
  }
});
function dotDigitalScript() {
  (function (w, d, u, t, o, c) {
    w.dmtrackingobjectname = o;
    c = d.createElement(t);
    c.async = 1;
    c.src = u;
    t = d.getElementsByTagName(t)[0];
    t.parentNode.insertBefore(c, t);
    w[o] = w[o] || function () {
      (w[o].q = w[o].q || []).push(arguments);
    };
  })(window, document, '//static.trackedweb.net/js/_dmptv4.js', 'script', 'dmPt');
  window.dmPt('create', dotDigital.insightId, dotDigital.shopDomain);
  // Setup the last browsed product
  if (product === undefined) {
    window.dmPt('track');
  } else {
    var viewedProduct = {
      product_name: product.title,
      product_url: product.url,
      product_image_path: product.featuredImage,
      product_sku: product.sku,
      product_price: product.price,
      product_currency: product.currency,
      product_brand: product.brand
    };
    window.dmPt('track', viewedProduct);
    if (customerEmail) {
      window.dmPt('identify', customerEmail);
    }
  }
}